import { useState } from 'react';

/**
 * Manual-only prev/next index cycling, shared by the Hero image slider and
 * the quote carousel (A-96, docs/specs/02-design.md §17) - both are
 * navigated by the visitor, never on a timer.
 */
export function useManualSlider(length: number) {
  const [index, setIndex] = useState(0);
  const safeLength = Math.max(length, 1);

  return {
    index: index % safeLength,
    next: () => setIndex((i) => (i + 1) % safeLength),
    prev: () => setIndex((i) => (i - 1 + safeLength) % safeLength),
    goTo: (i: number) => setIndex(i % safeLength),
  };
}
